import * as CONSTANTS from '../../constants';


/**
 * @name getGmiConstants
 * @desc Makes a deep clone of gmi constants that can be imported by app
 * @returns {Object}
 * @memberof utils
 **/
export function getGmiConstants() {
  return JSON.parse(JSON.stringify(CONSTANTS));
}
